import { config, logos } from "virtual:$histoire-config";
"use strict";
const histoireConfig = config;
const customLogos = logos;
export {
  customLogos,
  histoireConfig
};
